import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Trophy, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function ProductPresentation() {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [{
    id: 'personalidad',
    label: 'Personalidad',
    content: 'Descubrí el elemento dominante de tu hijo (Fuego, Tierra, Aire o Agua) y entendé por qué es como es desde su naturaleza más profunda, no desde lo que esperás que sea.'
  }, {
    id: 'emociones',
    label: 'Emociones',
    content: 'Herramientas prácticas para acompañar sus desbordes emocionales según su diseño. Lo que calma a un niño de Fuego, altera a uno de Tierra. Aprendé la diferencia.'
  }, {
    id: 'aprendizaje',
    label: 'Aprendizaje',
    content: 'El fin de las peleas por la tarea. Entendé cómo procesa la información tu hijo y adaptá el entorno para que aprender sea natural y no una batalla diaria.'
  }, {
    id: 'comunicacion',
    label: 'Comunicación',
    content: 'Descubrí su lenguaje del amor y cómo hablarle para que realmente te escuche. Frases exactas que conectan en lugar de generar resistencia.'
  }, {
    id: 'limites',
    label: 'Límites',
    content: 'Cómo sostener límites firmes sin gritos ni amenazas. Un sistema de contención adaptado a su personalidad que le da seguridad sin romper el vínculo.'
  }, {
    id: 'conexion',
    label: 'Conexión',
    content: 'El mapa para construir una relación de confianza a largo plazo. Rituales de conexión diarios específicos para su elemento.'
  }];
  return <SectionWrapper className="text-center" data-id="element-219">
      <div className="inline-flex items-center gap-2 bg-gold/20 text-text-main font-bold px-5 py-2 rounded-full mb-8 text-sm md:text-base" data-id="element-220">
        <Trophy size={18} className="text-gold" data-id="element-221" />
        Sistema N°1 de Crianza Consciente para Mamás Latinas
      </div>

      <h2 className="text-5xl md:text-7xl font-black text-burgundy mb-4" data-id="element-222">
        🌟 CÓDIGO HIJO
      </h2>

      <p className="text-xl md:text-2xl font-bold text-dusty-rose tracking-widest uppercase mb-8" data-id="element-223">
        MASTERCLASS COLLECTION
      </p>

      <p className="text-2xl md:text-3xl font-serif text-text-main max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-224">
        6 Tomos + 3 Bonus — Desde el primer berrinche hasta la conexión profunda
        — Todo resuelto.
      </p>

      <div className="bg-white p-6 rounded-2xl shadow-sm border border-dusty-rose/20 max-w-4xl mx-auto mb-16" data-id="element-225">
        <p className="text-lg text-text-main/80 font-medium leading-relaxed" data-id="element-226">
          +400 páginas · 6 guías completas · 3 bonus de emergencia ·
          Personalidad · Emociones · Aprendizaje · Comunicación · Límites ·
          Conexión.{' '}
          <strong className="text-burgundy" data-id="element-227">Funciona desde hoy.</strong>
        </p>
      </div>

      <div className="max-w-4xl mx-auto bg-card-bg rounded-3xl shadow-md border border-dusty-rose/30 overflow-hidden" data-id="element-228">
        <div className="flex flex-wrap border-b border-dusty-rose/20 bg-white" data-id="element-229">
          {tabs.map((tab, index) => <button key={tab.id} onClick={() => setActiveTab(index)} className={`flex-1 min-w-[120px] py-4 px-2 text-sm md:text-base font-bold transition-colors relative ${activeTab === index ? 'text-burgundy' : 'text-text-main/50 hover:text-text-main/80'}`} data-id="element-230">
              {tab.label}
              {activeTab === index && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-1 bg-burgundy" data-id="element-231" />}
            </button>)}
        </div>

        <div className="p-8 md:p-12 min-h-[200px] flex items-center justify-center bg-card-bg" data-id="element-232">
          <AnimatePresence mode="wait" data-id="element-233">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} className="text-xl md:text-2xl text-text-main/90 font-serif leading-relaxed" data-id="element-234">
              {tabs[activeTab].content}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </SectionWrapper>;
}